import { axiosInstance } from '../../../shared/api';

export async function getMFAStatus() {
	try {
		const response = await axiosInstance.get(`mfa/status`);
		if (response.status === 200) {
			return response.data;
		}
	} catch (error) {
		return error;
	}
}

export async function setupTOTP() {
	try {
		const response = await axiosInstance.post(`mfa/totp/setup`);
		if (response.status === 200) {
			return response.data;
		}
	} catch (error) {
		return error;
	}
}

export async function verifyTOTPSetup(code) {
	try {
		const response = await axiosInstance.post(`mfa/totp/verify`, { code });
		if (response.status === 200) {
			return response.data;
		}
	} catch (error) {
		return error;
	}
}

export async function disableTOTP(code) {
	try {
		const response = await axiosInstance.post(`mfa/totp/disable`, { code });
		if (response.status === 200) {
			return response.data;
		}
	} catch (error) {
		return error;
	}
}

export async function setupEmailMFA() {
	try {
		const response = await axiosInstance.post(`mfa/email/setup`);
		if (response.status === 200) {
			return response.data;
		}
	} catch (error) {
		return error;
	}
}

export async function verifyEmailMFASetup(code) {
	try {
		const response = await axiosInstance.post(`mfa/email/verify-setup`, {
			code,
		});
		if (response.status === 200) {
			return response.data;
		}
	} catch (error) {
		return error;
	}
}

export async function disableEmailMFA() {
	try {
		const response = await axiosInstance.post(`mfa/email/disable`);
		if (response.status === 200) {
			return response.data;
		}
	} catch (error) {
		return error;
	}
}

export const updateProfile = async data => {
	try {
		const response = await axiosInstance.put(`users/profile`, data);
		return response;
	} catch (error) {
		// Return error in a consistent format for the component to handle
		return error;
	}
};

// Add new function for uploading profile picture
export const uploadProfilePicture = async file => {
	try {
		const formData = new FormData();
		formData.append('picture', file);

		const response = await axiosInstance.post(
			`users/profile/picture`,
			formData,
		);

		if (response.status === 200) {
			return response.data;
		}
	} catch (error) {
		console.error('Upload profile picture error:', error);
		throw error;
	}
};

// Add function for deleting profile picture
export const changePassword = async passwordData => {
	try {
		const response = await axiosInstance.post(`users/password`, passwordData);
		return response;
	} catch (error) {
		// Return error in a consistent format for the component to handle
		return error;
	}
};

export const deleteProfilePicture = async () => {
	try {
		const response = await axiosInstance.delete(`users/profile/picture`);

		if (response.status === 200) {
			return response.data;
		}
	} catch (error) {
		console.error('Delete profile picture error:', error);
		throw error;
	}
};
